/// <amd-module name="Build/Run/RunHeaderBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class RunHeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {

    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumbs(pipelineName: string, pipelineUrl: string, runNumber: string, runUrl: string) {
        this.items.removeAll();

        this.items.push({
            key: "pipeline-breadcrumb",
            text: pipelineName,
            href: pipelineUrl,
            onClick: (ev) => {
                onClickFPS(this.pageContext, pipelineUrl, true, ev, { telemetrySource: "pipeline-breadcrumb" });
            }
        });

        this.items.push({
            key: "run-breadcrumb",
            text: runNumber,
            href: runUrl,
            onClick: (ev) => {
                onClickFPS(this.pageContext, runUrl, true, ev, { telemetrySource: "run-breadcrumb" });
            }
        });
    }

    public clearBreadcrumbs() {
        this.items.removeAll();
    }
}

Services.add("run-header-breadcrumb-service", { serviceFactory: RunHeaderBreadcrumbService });